import React from 'react';
import styled from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import ReviewItem from '@/components/templates/review/ReviewItem';
import { EReviewType, Review, ReviewTargetType } from '@/models/review/review';
import theme from '@/styles/theme';

interface Props {
  review: Review;
  onClickMenu: () => void;
  clickLikeReview: (reviewId: number, isLiked: boolean, type?: EReviewType) => void;
  isOtherUsersPrivateReview: (review: Review) => boolean;
}
const BestReviewItem = ({ review, onClickMenu, clickLikeReview, isOtherUsersPrivateReview }: Props) => {
  return (
    <ReviewItemContainer>
      <ReviewItemWrapper>
        <BestBadgeWrapper>
          <BestBadge>
            <MaterialIcon name={'thumb_up'} size={14} filled={true} color={theme.color.white} />
            <BestBadgeText
              style={{
                color: theme.color.white,
              }}
            >
              BEST
            </BestBadgeText>
          </BestBadge>
          <BestReviewGuideText
            style={{
              color: theme.color.blue700,
            }}
          >
            가장 도움이 된 후기예요
          </BestReviewGuideText>
        </BestBadgeWrapper>
        <ReviewItem
          review={review}
          onClickMenu={onClickMenu}
          isHideContent={isOtherUsersPrivateReview(review)}
          clickLikeReview={() => clickLikeReview(Number(review.id), review.isLiked, EReviewType.BEST)}
          reviewTargetType={ReviewTargetType.DOCTOR}
        />
      </ReviewItemWrapper>
    </ReviewItemContainer>
  );
};
export default BestReviewItem;

const ReviewItemContainer = styled.div``;

const ReviewItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const BestBadgeWrapper = styled.div`
  display: flex;
  padding: 20px 24px 0 24px;
  align-items: center;
  gap: 6px;
`;

const BestBadge = styled.div`
  padding: 1px 4px;
  border-radius: 2px;
  gap: 2px;
  background: ${theme.color.blue500};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BestBadgeText = styled.span`
  ${({ theme }) => `
    ${theme.typography.UI12M};
    color: ${theme.color.white};
  `};
`;

const BestReviewGuideText = styled.span`
  ${({ theme }) => `
    ${theme.typography.UI13SB};
    color: ${theme.color.blue700};
  `};
`;
